// for all elements that have the attribute `data-ultra-confirm`,
// show a confirmation dialog when they are clicked and ask the user to enter
// the value in data-ultra-confirm-confirmation

const setupUltraConfirm = () => {
  for (const element of document.querySelectorAll('[data-ultra-confirm]')) {
    element.addEventListener('click', event => {
      const message = element.getAttribute('data-ultra-confirm') || 'Are you sure?';
      const confirmation = element.getAttribute('data-ultra-confirm-challenge') || 'CONFIRM';
      const userInput = globalThis.prompt(`${message}\n\nPlease type "${confirmation}" to confirm.`);
      if (userInput !== confirmation) {
        event.preventDefault();
        event.stopImmediatePropagation();
        alert('Action cancelled.');
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', setupUltraConfirm);
document.addEventListener('turbo:load', setupUltraConfirm);
